module.exports = __webpack_public_path__ + "a63dcd83127ecfd08208a274259ee373.woff2";